var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-progress-linear',{attrs:{"value":_vm.progress,"buffer-value":_vm.progress,"height":"6","color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }